import {Line, mixins} from 'vue-chartjs';
import Chart from 'chart.js';

Chart.pluginService.register({
  afterDraw: function (chart, easing) {
    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
      // var helpers = Chart.helpers;
      let expectedValue = chart.data.expectedValue;
      let data = chart.data.datasets[0].data;
      let ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;
      // // console.log(chartArea.bottom);
      //
      // // console.log(chart.config.options.dataSize);
      ctx.save();
      ctx.strokeStyle = 'rgba(0, 0, 0)'; // chart.config.options.chartArea.backgroundColor;
      ctx.lineWidth = 2;
      ctx.setLineDash([7, 3]);
      if (data && data.length) {
        ctx.beginPath();
        let maxY = Math.max(expectedValue, Math.max(...data));
        let maxVal = (parseInt((maxY / 10 + 0.5)) * 10 + Math.max(10, maxY * 0.1));
        let topLine = chartArea.bottom - (((chartArea.bottom - chartArea.top) * expectedValue) / maxVal);
        ctx.moveTo(chartArea.left - 10, topLine);
        ctx.lineTo(chartArea.right, topLine);
        ctx.stroke();

        // draw text expected
        ctx.font = '600 12px OpenSans';
        ctx.fillStyle = '#1D1D1D';
        ctx.textAlign = 'center';

        ctx.fillText('expected sign ups', (chartArea.right + chartArea.left) / 2, topLine - 20 < 0 ? topLine + 16 : topLine - 12);

        let topFooter = chartArea.bottom + 16;
        ctx.fillStyle = '#424242';
        ctx.textAlign = 'center';
        ctx.fillText(chart.data.startDate, chartArea.left / 2 + 25, topFooter);
        ctx.fillText(chart.data.endDate, chartArea.right - 15, topFooter);

        topFooter += 14;
        ctx.fillStyle = '#8E8E8E';
        ctx.fillText('Event Live', chartArea.left / 2 + 25, topFooter);
        ctx.fillText('Current Day', chartArea.right - 15, topFooter);
        // draw labels
      }
      ctx.restore();
    }
  }
});

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    labels: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    },
    expectedValue: 0,
    startDate: '',
    endDate: ''
  },
  mounted () {
  },
  watch: {
    data: {
      handler: function () {
        let maxValue = Math.max(this.expectedValue, Math.max(...this.data));
        this.renderChart({
          // array data label from index 0, 1, ... =count

          labels: this.labels,
          expectedValue: this.expectedValue,
          startDate: this.startDate,
          endDate: this.endDate,
          datasets: [
            {
              label: '',
              // array data value at position 0, 1, 2...=count-1
              data: this.data,
              backgroundColor:
                'rgba(0, 0, 0, 0)',
              borderColor: 'rgba(139, 197, 213, 0.8)',
              pointBackgroundColor: 'rgba(139, 197, 213, 0.8)',
              pointBorderWidth: 1,
              pointRadius: 4,
              borderWidth: 3,
              pointHoverRadius: 20,
              showLine: true,

              lineTension: 0.1 // smooth line
              // steppedLine: true,
            }
          ]
        }, {
          dataSize: this.data.length,
          chartArea: {
            backgroundColor: '#f5f5f5'
            // backgroundColor: '#ff0000'
          },
          layout: {
            padding: {
              left: 0,
              right: 30,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(66,66,66,1)',
                display: false,
                drawBorder: false
              },
              ticks: {
                padding: 15 // spacing with label
              }
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(221, 221, 221, 0.8)',
                display: true,
                drawBorder: false,
                zeroLineColor: 'rgba(221, 221, 221, 0.8)'
              },
              ticks: {
                padding: 5,
                min: 0,
                max: (parseInt((maxValue / 10 + 0.5)) * 10 + Math.max(10, maxValue * 0.1)) // calculate max data value
              }
            }]
          },
          legend: {
            display: false // hide header
          },
          tooltips: {
            enabled: true
          },

          responsive: true,
          maintainAspectRatio: false
        });
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/eventManagement/reports/event-chart.js